import classNames from "classnames";
import { Formik, FormikProps } from "formik";
import { useCallback } from "react";
import { ObjectSchema } from "yup";
import { IFilterProps } from "../../../../../models";

interface IAvisFilterProps<T extends IFilterProps> {
  filter: T | undefined;
  filtered: boolean;
  validationSchema: ObjectSchema<T>;
  loading?: boolean;
  className?: string;
  setFilter: (val: T) => void;
  setRefresh: (val: boolean) => void;
  renderForm: (
    formikProps: FormikProps<T>,
    loading: boolean,
    filtered: boolean,
  ) => React.ReactNode;
}

export function AvisFilter<T extends IFilterProps>(
  props: Readonly<IAvisFilterProps<T>>,
) {
  const {
    filter,
    filtered,
    loading = false,
    validationSchema,
    className,
    setFilter,
    setRefresh,
    renderForm,
  } = props;

  const handleSubmit = (values: T) => {
    values.pageIndex = 0;
    setFilter(values);
    setRefresh(true);
  };

  const renderFormCallback = useCallback(
    (formikProps: FormikProps<T>) => {
      return renderForm(formikProps, loading, filtered);
    },
    [loading, renderForm, filtered],
  );

  if (!filter) return;

  const classNameFilter = classNames("avis-list-filter", className);
  return (
    <div className={classNameFilter}>
      <Formik<T>
        initialValues={filter}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        validateOnChange={false}
      >
        {renderFormCallback}
      </Formik>
    </div>
  );
}
